import { useEffect, useState } from "react";
import { HelpCircle, ChevronDown, Phone } from "lucide-react";
import api from "@/lib/api";
import { PageShell } from "@/components/PageShell";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [event, setEvent] = useState(null);
  const [open, setOpen] = useState(0);

  useEffect(() => {
    api.get("/faqs").then((r) => setFaqs(r.data));
    api.get("/event").then((r) => setEvent(r.data));
  }, []);

  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-5 lg:px-8 py-16">
        <div className="flex items-center gap-3">
          <HelpCircle className="text-sky-600" />
          <h1 className="font-display text-4xl lg:text-5xl text-slate-900">FAQs</h1>
        </div>
        <p className="mt-3 text-slate-600 text-lg">Everything you need to know about the day.</p>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => (
            <div key={f.id} data-testid={`faq-${i}`} className="rounded-2xl border border-slate-100 bg-white overflow-hidden">
              <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left">
                <span className="font-semibold text-slate-900">{f.question}</span>
                <ChevronDown className={`shrink-0 text-slate-400 transition-transform ${open === i ? "rotate-180" : ""}`} size={20} />
              </button>
              {open === i && <div className="px-6 pb-5 text-slate-600 leading-relaxed">{f.answer}</div>}
            </div>
          ))}
        </div>

        {event?.contacts && (
          <div className="mt-12 rounded-3xl bg-secondary p-8">
            <h2 className="font-display text-2xl text-slate-900">Still have questions?</h2>
            <p className="mt-1 text-slate-600">Contact the organisers to enter a player or team:</p>
            <div className="mt-5 grid sm:grid-cols-2 gap-3">
              {event.contacts.map((c) => (
                <a key={c.phone} href={`tel:${c.phone.replace(/\s/g, "")}`} className="flex items-center gap-3 rounded-xl bg-white p-4 hover:-translate-y-0.5 transition-transform">
                  <span className="h-9 w-9 grid place-items-center rounded-full bg-sky-100 text-sky-600"><Phone size={16} /></span>
                  <div>
                    <p className="font-semibold text-slate-900 text-sm">{c.name}</p>
                    <p className="text-sm text-slate-500">{c.phone}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        )}
      </div>
    </PageShell>
  );
}
